import Vue from 'vue';

import BaseButton from './BaseButton/BaseButton.vue';
import CheckboxButton from './CheckboxButton.vue';
import Navbar from './Navbar/Navbar.vue';
import Form from './Form.vue';
import Footer from './Footer.vue';
import PaymentCard from './PaymentCard.vue';
import './elements';
import Loading from './Loading.vue';

Vue.component(BaseButton.name, BaseButton);
Vue.component(CheckboxButton.name, CheckboxButton);
Vue.component(Navbar.name, Navbar);
Vue.component(Form.name, Form);
Vue.component(Footer.name, Footer);
Vue.component(PaymentCard.name, PaymentCard);
Vue.component(Loading.name, Loading);
